module.exports = __webpack_public_path__ + "static/media/google-signin.d6fe6bd4.png";